import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'


export default class extends React.Component {
    static propTypes = {
		ID: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		slug: PropTypes.string.isRequired,
		post_type: PropTypes.object.isRequired,
		date: PropTypes.string.isRequired,
		description: PropTypes.string,
		bookmarks: PropTypes.array.isRequired,
		answers: PropTypes.number.isRequired,
		camp: PropTypes.object
	};

    render() {
		return (
			<div className="col-sm-12 panel ptop15 mbot0">
				<Link to={this.props.link}>
					<h3>{this.props.title}</h3>
				</Link>
	    		<p className="lead mbot20">{this.props.description}</p>
	    		{this.props.camp.hasOwnProperty('name') && 
	    			<p className="mbot10">
	    				<Link to={this.props.camp.link}>
							<i className="fa fa-compass"></i> 
		    				{this.props.camp.name}
	    				</Link>
    				</p>
				}
	    		<p className="mbot20">
	    			<span className="text-mid-success mright10">{this.props.flares.length} <i className='fa fa-arrow-up'></i></span>
	    			<span className="text-yellow mright10">{this.props.bookmarks.length} <i className='fa fa-star'></i></span>
	    			<span className="text-mid-main">{this.props.answers} <i className='fa fa-comment'></i></span>
    			</p>
        	</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/ContentPart-Question.jsx